'use client'

import React from 'react'
import { useSearchParams } from '@/lib/hooks'
import { ProductsGrid } from '@/components/molecules'

export const ProductsSection = () => {
  const { isCheckout } = useSearchParams()

  if (isCheckout) {
    return null
  }

  return <ProductsGrid />
}

